module.exports = __webpack_public_path__ + "img/Main-Library-t-25267-001.11712646.jpg";